export class CloseAlert {
  constructor(){
    return {
      link: function(scope, element, attr) {
        element.on('click', function(){
          $(attr.closeAlert).slideUp(400, () => {
            scope.slidebars.slidebars.css();
          });
        })
      }
    }
  }
}
